import { render, staticRenderFns } from "./publicManage.vue?vue&type=template&id=7779825e&scoped=true&"
import script from "./publicManage.vue?vue&type=script&lang=js&"
export * from "./publicManage.vue?vue&type=script&lang=js&"
import style0 from "./publicManage.vue?vue&type=style&index=0&id=7779825e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7779825e",
  null
  
)

export default component.exports